import { useMemo, useState } from "react";
import { Icons } from "../../../assets/images/icons";
import { AppButton } from "../../../components/ui/AppButton";
import { DataTable } from "../../../components/ui/data-table";
import WithAuth from "../../../hoc/WithAuth";
import { FarmingStageType } from "../../../types";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { useParams } from "react-router-dom";
import { useGetFarmingStageByOrderId } from "../../../api/farming_stage";

const FarmingStage = () => {
  const { id } = useParams();

  const pageSize = 10;

  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState<number>(1);

  // API calls
  const { data: trackingData, isLoading } = useGetFarmingStageByOrderId(id);

  const transformedFarmingStage = useMemo((): FarmingStageType[] => {
    if (!trackingData?.data?.data?.content) return [];

    return trackingData?.data?.data?.content.map((item: FarmingStageType) => ({
      id: item.id,
    }));
  }, [trackingData?.data]);

  const filteredFarmingStage = useMemo(() => {
    let filtered = transformedFarmingStage;

    return filtered;
  }, [transformedFarmingStage]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredFarmingStage.slice(startIndex, startIndex + pageSize);
  }, [currentPage, filteredFarmingStage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const farmingStageColumns = [
    {
      key: "index",
      title: "#",
      dataIndex: "index",
      align: "center" as const,
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      key: "fullName",
      title: "Full Name",
      dataIndex: "fullName",
      align: "left" as const,
      render: (text: string) => (
        <div className="truncate max-w-[200px]" title={text}>
          {text}
        </div>
      ),
    },
    {
      key: "email",
      title: "Email",
      dataIndex: "email",
      align: "left" as const,
      render: (text: string) => (
        <div className="truncate max-w-[200px]" title={text}>
          {text}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      dataIndex: "phoneNumber",
      align: "left" as const,
    },
    {
      key: "actions",
      title: "Actions",
      align: "center" as const,
      render: (_: any, record: FarmingStageType) => (
        <Button
          variant="destructive"
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
          }}
          // disabled={}
          className="h-8 p-0 w-full gap-2 text-[#C41919]"
        >
          <img src={Icons.deleteIcon} alt="delete" className="h-4 w-4" />
          Remove
        </Button>
      ),
    },
  ];

  const handleSearch = (value: string) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const handleExport = () => {
    // Export logic goes here
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between">
        {/* Search - Desktop */}
        <div className="relative w-full lg:w-64">
          <Input
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search farming stage by name"
            className="pl-10 rounded-2xl w-[308px] h-11"
          />
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            <img src={Icons.search} alt="search" className="w-6 h-6" />
          </div>
        </div>

        <div className="flex gap-2">
          <AppButton
            customIcon={Icons.printIcon}
            variant="outline"
            onClick={handlePrint}
            className="bg-white text-gray-700 hover:bg-gray-50 border-gray-300"
          >
            Print
          </AppButton>
          <AppButton
            customIcon={Icons.fileExport}
            onClick={handleExport}
            className="bg-[#DDDDDD] hover:bg-gray-300"
          >
            Export
          </AppButton>
        </div>
      </div>

      {/* Desktop Table View */}
      <div className="hidden md:block">
        <DataTable<FarmingStageType>
          data={paginatedData}
          columns={farmingStageColumns}
          loading={isLoading}
          pagination={{
            current: currentPage,
            pageSize,
            total: filteredFarmingStage.length,
            onChange: handlePageChange,
          }}
          rowKey="id"
          emptyText="No farming stage data found"
          emptyIcon={<img src={Icons.noDataIcon} alt="No data" />}
        />
      </div>
    </>
  );
};

export default WithAuth(FarmingStage);
